module.exports = __webpack_public_path__ + "img/resize.b4eb247.svg";